import { render, staticRenderFns } from "./InputYearsMonths.vue?vue&type=template&id=f2fe00d6&scoped=true"
import script from "./InputYearsMonths.vue?vue&type=script&lang=js"
export * from "./InputYearsMonths.vue?vue&type=script&lang=js"
import style0 from "./InputYearsMonths.vue?vue&type=style&index=0&id=f2fe00d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fe00d6",
  null
  
)

export default component.exports